import { Box, HStack, VStack } from '@chakra-ui/react'
import _ from 'lodash'
import { useContext, useState } from 'react'

import { AuthContext } from 'contexts'

import useIsMobile from 'utils/useIsMobile'

import AppsSelectorBody from './AppsSelectorBody'
import AppsSelectorHeader, {
  AppsSelectorDropdownType,
  selectAllOption,
} from './AppsSelectorHeader'
import AppsGlobalSearch from './AppsGlobalSearch'
import { getIsGov } from 'contexts/ClientType'

const AppsSelectorPage = () => {
  const [isMobile] = useIsMobile()
  const isGov = getIsGov()
  const { appletGroupsUserCanSee } = useContext(AuthContext)

  const [selectedCategory, setSelectedCategory] =
    useState<AppsSelectorDropdownType>(selectAllOption)

  const appletGroupsToShow = _.sortBy(
    selectedCategory.value === null
      ? Object.values(appletGroupsUserCanSee)
      : Object.values(appletGroupsUserCanSee).filter(
          (appletGroup) => appletGroup.category === selectedCategory.value
        ),
    'order'
  ).filter((appletGroup) => !appletGroup.hidden)

  if (isMobile) {
    return (
      <VStack
        px={[6, 6]}
        pt={10}
        mx={[4, 4]}
        marginX='auto'
        alignItems='flex-start'
        spacing={6}
      >
        <VStack
          maxW='1100px'
          pt={10}
          mx={[4, 4]}
          marginX='auto'
          alignItems='flex-start'
          spacing={10}
          w='100%'
        >
          <Box w='100%'>
            <AppsSelectorHeader
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              hideSelector
            />
          </Box>
          <Box overflow='auto' height='100%'>
            <AppsSelectorBody appletGroupsToShow={appletGroupsToShow} />
          </Box>
        </VStack>
      </VStack>
    )
  }

  return (
    <VStack>
      <HStack alignItems='flex-start' w='100%'>
        {isGov && <AppsGlobalSearch />}
        <VStack
          maxW={isGov ? '1100px' : ''}
          mx={[4, 10]}
          marginX='auto'
          alignItems='flex-start'
          spacing={10}
          w={isGov ? '50%' : '100%'}
          pt={10}
        >
          <Box w='100%'>
            <AppsSelectorHeader
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              hideSelector
            />
          </Box>
          <Box overflow='auto' height='100%'>
            <AppsSelectorBody appletGroupsToShow={appletGroupsToShow} />
          </Box>
        </VStack>
      </HStack>
    </VStack>
  )
}

export default AppsSelectorPage
